import * as Yup from 'yup';
import {useTranslation} from "react-i18next";

export const useAmountValidation = ()=>{
    const {t} = useTranslation('common');

    const digitsOnly = (value) => /^\d*[.{1}\d*]\d*$/.test(value) || value.length === 0;

    return Yup.string().test('inputEntry', t('amount'), digitsOnly);
}
